<!-- <div class="wraper"> -->
<!-- <app-navbar></app-navbar> -->
<app-dashboard-navbar></app-dashboard-navbar>
<div class="content-wraper">
        <div class="superadmindb">
    <app-breadcrumb></app-breadcrumb>
    <!-- <app-sidebar></app-sidebar> -->
    <!-- <div class="content-side scrolling page_width"> -->






    <!-- <div *ngIf="showIcon">
                <div class="iconBlock">
                    <div class="icon_group col-md-2" *ngFor="let data of menuListData">
                        <a (click)="viewDetailFromMenu(data)">
                            <figure class="{{data.gstibo_menu_style}}">
                                <svg class="icon">
                                    <use [attr.xlink:href]="menuIcon+data.gstibo_icon"></use>
                                </svg>
                            </figure>
                            <figcaption>{{data.gstibo_menu_name}}{{(adminSelectedTopMenu == data.gstibo_menu_name ? '1' : '0')}}</figcaption>
                        </a>
                    </div>
                </div>
            </div> -->
    <router-outlet>

    </router-outlet>
    <!-- </div> -->
</div>
</div>
<!-- </div> -->